<script lang="ts">
    import { Component, Prop, Vue } from "vue-property-decorator";
    @Component
    export default class ScrollBar extends Vue {
        @Prop()
        vertical;
        @Prop()
        move;
        @Prop()
        size;
        @Prop()
        canScroll;

        get scrollBarEl() {
            return (this.$parent as any).scrollBar as HTMLElement;
        }
        get scrollViewEl() {
            return (this.$parent as any).scrollView as HTMLElement;
        }
        get thumbStyle() {
            let style = {
                transform: "",
                height: "100%",
                width: "100%",
            };
            if (this.vertical) {
                style.transform = `translateY(${this.move}%)`;
                style.height = this.size;
            } else {
                style.transform = `translateX(${this.move}%)`;
                style.width = this.size;
            }
            return style;
        }
        get scrolltrack() {
            return this.$refs.scrolltrack as HTMLElement;
        }
        get scrollThumb() {
            return this.$refs.scrollThumb as HTMLElement;
        }
        mousedownThumb(e: MouseEvent) {
            e.preventDefault();
            this.mouseDown = true;
            let start = this.vertical ? e.clientY : e.clientX;
            let tempMove = this.move;
            document.onmousemove = (ev: MouseEvent) => {
                const parent = this.scrollViewEl;
                let parentScrollSize = this.vertical ? parent?.scrollHeight : parent?.scrollWidth;
                let barSize = this.vertical ? this.scrolltrack.clientHeight : this.scrolltrack.clientWidth;
                let offset = (this.vertical ? ev.clientY : ev.clientX) - start;
                let percent = offset / barSize;
                let old = (tempMove * this.scrollViewEl.clientHeight) / 100;
                let current = percent * parentScrollSize;
                this.$emit("setScroll", old + current);
            };
            document.onmouseup = () => {
                this.mouseDown = false;
                if (this.mouseStatus == "mouseleave") {
                    this.visible = false;
                }
                document.onmousemove = null;
                document.onmouseup = null;
            };
        }

        clickBar(e: MouseEvent) {
            const parent = this.scrollViewEl;
            let parentScrollSize = this.vertical ? parent?.scrollHeight : parent?.scrollWidth;
            let thumbSize = this.vertical ? this.scrollThumb.clientHeight : this.scrollThumb.clientWidth;
            let barSize = this.vertical ? this.scrolltrack.clientHeight : this.scrolltrack.clientWidth;
            let centerPercent = thumbSize / 2 / barSize;

            let rect = this.scrolltrack.getBoundingClientRect();
            let position = this.vertical ? e.clientY - rect.top : e.clientX - rect.left;
            let percent = position / barSize;
            let clickScroll = percent * parentScrollSize;
            let centerScroll = centerPercent * parentScrollSize;
            this.$emit("setScroll", clickScroll - centerScroll, true);
        }

        visible = true;
        mouseDown = false;
        mouseStatus = "";
        toggleShow(e: MouseEvent) {
            this.mouseStatus = e.type;
            this.visible = e.type == "mouseenter" ? true : this.mouseDown;
        }
        mounted() {
            this.$nextTick(() => {
                this.scrollBarEl.addEventListener("mouseenter", this.toggleShow);
                this.scrollBarEl.addEventListener("mouseleave", this.toggleShow);
            });
        }
    }
</script>

<template>
    <div ref="scrolltrack" class="xx-scrollbar-outer" :class="vertical ? 'xx-scrollbar-vertical' : 'xx-scrollbar-horizontal'" @click="clickBar">
        <Transition name="xx-scrollbar-fade">
            <div
                ref="scrollThumb"
                v-show="canScroll && visible"
                class="xx-scrollbar-inner"
                @mousedown.stop="mousedownThumb"
                :style="thumbStyle"
            ></div>
        </Transition>
    </div>
</template>

<style lang="stylus" scoped>
    .xx-scrollbar-outer
        position absolute
        right 2px
        bottom 2px
        z-index 1
        border-radius: 4px
        cursor pointer
        &.xx-scrollbar-vertical
            top 2px
            width 6px
        &.xx-scrollbar-horizontal
            left 2px
            height 6px
        .xx-scrollbar-inner
            background var(--bg-color-scrollbar-component)
            border-radius inherit
            &:hover
                cursor pointer
    .xx-scrollbar-fade-enter-active{
      transition: opacity 340ms ease-out;
    }
    .xx-scrollbar-fade-leave-active {
      transition: opacity 220ms ease-out;
    }

    .xx-scrollbar-fade-enter,
    .xx-scrollbar-fade-leave-to {
      opacity: 0;
    }
</style>
